import React, { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";
import useReactApexChart from "../../hook/useReactApexChart";

const GeneratedContent = ({ dashboardData }) => {
  const [timeframe, setTimeframe] = useState("Monthly");
  const { EarningChartSeries, EarningChartOptions } =
    useReactApexChart(timeframe);
  const handleTimeframeChange = (e) => {
    setTimeframe(e.target.value);
  };
  return (
    <div className="col-xxl-12">
      <div className="card h-100">
        <div className="card-body">
          <div className="d-flex align-items-center flex-wrap gap-2 justify-content-between">
            <h6 className="mb-2 fw-bold text-lg mb-0">Earning Review</h6>
            <select
              className="form-select form-select-sm w-auto bg-base border text-secondary-light"
              value={timeframe}
              onChange={handleTimeframeChange}
            >
              <option value="Weekly">Weekly</option>
              <option value="Monthly">Monthly</option>
              <option value="Yearly">Yearly</option>
            </select>
          </div>
          <div className="mt-40">
            <div className="margin-16-minus">
              <ReactApexChart
                options={EarningChartOptions}
                series={EarningChartSeries}
                type="area"
                height={250}
                dashboardDatas={dashboardData}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GeneratedContent;
